import React from 'react'

import { UserEligibilityType } from 'features/auth/helpers/getEligibilityType'
import { HighlightedBody } from 'features/profile/components/HighlightedBody/HighlightedBody'
import { useRemoteConfigQuery } from 'libs/firebase/remoteConfig/queries/useRemoteConfigQuery'
import { getIsUserEligibleFree } from 'shared/user/checkEligibilityType'
import { useDepositAmountsByAge } from 'shared/user/useDepositAmountsByAge'
import { InternalTouchableLink } from 'ui/components/touchableLink/InternalTouchableLink'
import { ViewGap } from 'ui/components/ViewGap/ViewGap'
import { Button } from 'ui/designSystem/Button/Button'
import { Offers } from 'ui/svg/icons/Offers'
import { Typo } from 'ui/theme'

export const EmptyCredit = ({
  age,
  eligibilityType,
}: {
  age: number
  eligibilityType?: UserEligibilityType | null
}) => {
  const {
    data: { homeEntryIdFreeOffers },
  } = useRemoteConfigQuery()

  const { sixteenYearsOldDeposit, seventeenYearsOldDeposit, eighteenYearsOldDeposit } =
    useDepositAmountsByAge()

  const incomingCreditMap: Record<number, string> = {
    15: sixteenYearsOldDeposit,
    16: seventeenYearsOldDeposit,
    17: eighteenYearsOldDeposit,
  }

  if (!incomingCreditMap[age]) return null

  const ageToShowCreditV3 = age === 17 ? 17 : 16

  const isUserFreeStatus = getIsUserEligibleFree(eligibilityType)

  const nextCreditIntroText = isUserFreeStatus
    ? 'Tu pourras débloquer ton prochain crédit de '
    : 'Ton prochain crédit de '

  const nextCreditTimingText = isUserFreeStatus ? ' à ' : ' sera débloqué à '

  return (
    <ViewGap gap={4}>
      <Typo.Body>
        {nextCreditIntroText}
        <HighlightedBody>{incomingCreditMap[ageToShowCreditV3]}</HighlightedBody>
        {nextCreditTimingText}
        {ageToShowCreditV3 + 1} ans. En attendant…
      </Typo.Body>
      <InternalTouchableLink
        as={Button}
        wording="Profite d’offres gratuites"
        navigateTo={{
          screen: 'ThematicHome',
          params: { homeId: homeEntryIdFreeOffers, from: 'profile' },
        }}
        icon={Offers}
      />
    </ViewGap>
  )
}
